@for (error of errorMsg$ | async; track error) {
<div class="text-danger mb-1">
  {{ (error | translate) }}
</div>
}

@for (info of infoMsg$ | async; track info) {
<div class="text-success mb-1">
  {{ (info | translate) }}
</div>
}
